var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00341 16.001C6.42126 16.001 4.87464 15.5318 3.55913 14.6528C2.24361 13.7738 1.2183 12.5244 0.612836 11.0627C0.00737229 9.60102 -0.151044 7.99258 0.157618 6.44083C0.46628 4.88908 1.22816 3.46371 2.34691 2.34496C3.46566 1.22621 4.89103 0.464327 6.44279 0.155665C7.99454 -0.152998 9.60297 0.00541916 11.0647 0.610882C12.5264 1.21635 13.7758 2.24166 14.6548 3.55717C15.5337 4.87268 16.0029 6.4193 16.0029 8.00146C16.0005 10.1223 15.157 12.1556 13.6573 13.6553C12.1576 15.155 10.1243 15.9986 8.00341 16.001ZM6.61291 5.60446V6.47296L7.72591 6.66496V11.948L6.61291 12.14V13.001H10.1874V12.14L9.07441 11.948V5.60446H6.61291ZM7.72591 2.33596V3.70996H9.07591V2.33596H7.72591Z",
    fill: "#3D96F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/Info-icon.2a5285b101a67d4af53537ce4ce87cac.svg";
export { ForwardRef as ReactComponent };